import { locale } from 'services/locale/fr-fr';
import { languages } from 'services/locale';

export const initialState = { locale, lang: languages.FR };
